import { Box } from '@mui/material';
import { useStyles } from './Welcome.styles';
import { Icons } from '../../../../../../icons';
import LoveCare from '../../../../../../icons/lotties/lottieIcons/LoveCare';
import { colors } from '../../../../../../colors';
const Welcome = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.welcomeFrame}>
        <Box display="flex" flexDirection="column" flexGrow={1} flex={1} gap="4px">
          <p className={classes.sectionTitle}>
            Important Information
          </p>
          <p className={classes.sectionSubtitle}>
            Let's begin by checking in
          </p>
        </Box>
        <LoveCare className={classes.animatedIcon} />
      </Box>
      <Box className={classes.askBox}>
        <Box className={classes.contentHeader}>
          <Icons glyph={"question-outlined"} className={classes.askIcon}/>
          <p className={classes.firstLine}>
            You may want to <span style={{fontWeight: 700, color: colors.secondary600}}>ask</span> things like:
          </p>
        </Box>
        <Box className={classes.askContent}>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.secondary100}}>
            How have you been since our last session?
          </Box>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.secondary100}}>
            Is there anything you’d like to share before we get started?
          </Box>
        </Box>
      </Box>
      <Box className={classes.askBox}>
        <Box className={classes.contentHeader}>
          <Icons glyph={"chat-outlined"} className={classes.sayIcon}/>
          <p className={classes.firstLine}>
            You may want to <span style={{fontWeight: 700, color: colors.success600}}>say</span> things like:
          </p>
        </Box>
        <Box className={classes.askContent}>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.success100}}>
            We’ll be reviewing our treatment plan and checking in on how things are going.
          </Box>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.success100}}>
            I’ll ask you some questions to make sure we’re on track.
          </Box>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.success100}}>
            We can use this time however is most beneficial for you.
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
export { Welcome };
